/* ==========================================================================
   PizzAmica — interazioni del tema

   Un unico file, nessun import: index.html lo carica come script classico,
   così Parcel emette un solo dist/main.js e l'enqueue di WordPress resta
   banale. Le sezioni sono numerate, come nel CSS.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. LA PIZZA CHE SEGUE LO SCROLL

     Tre fasi, tutte calcolate sulla posizione di scroll: nessuna animazione
     "a tempo", quindi il movimento è sempre reversibile.

       A — entrata   sale dal fondo finché non se ne vede esattamente metà
       B — viaggio   resta a filo del bordo inferiore e ruota
       C — uscita    rientra sotto il bordo e lascia la scena alla row finale

     Gli estremi del tragitto non sono numeri qui dentro: l'inizio è la row che
     contiene l'elemento del builder, la fine è la row il cui Row ID è stato
     scritto nell'elemento.
     ------------------------------------------------------------------ */
  function initPizza() {
    var stage = document.querySelector('[data-pizza-stage]');
    if (!stage) { return; }

    var inner = stage.querySelector('[data-pizza-inner]');
    var uid = stage.getAttribute('data-pizza-anchor');
    var marker = document.querySelector('[data-pizza-anchor="' + uid + '"]:not([data-pizza-stage])');

    // Senza segnaposto non sappiamo da dove far salire la pizza: meglio niente
    // che una pizza ferma in mezzo allo schermo.
    if (!inner || !marker) { stage.remove(); return; }

    var startEl = marker.closest('.wpb_row') || marker.parentElement;
    var endId = stage.getAttribute('data-pizza-end');
    var endEl = endId ? document.getElementById(endId) : null;

    var SPIN = parseFloat(stage.getAttribute('data-pizza-spin'));
    if (!isFinite(SPIN)) { SPIN = 1080; }

    var hideBelow = parseInt(stage.getAttribute('data-pizza-hide-below'), 10) || 0;

    var mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mqNarrow = hideBelow > 0
      ? window.matchMedia('(max-width: ' + (hideBelow - 1) + 'px)')
      : null;


    /* --- l'immagine: una a caso fra quelle scelte nel builder ---
       Il PHP stampa tutti gli URL, la scelta la facciamo qui: così il random
       sopravvive alla cache di pagina e si scarica una sola immagine. */
    var img = null;

    function mountImage() {
      if (img) { return; }

      var srcs;
      try { srcs = JSON.parse(stage.getAttribute('data-pizza-srcs') || '[]'); }
      catch (e) { srcs = []; }
      if (!srcs.length) { return; }

      img = new Image();
      img.alt = '';
      img.decoding = 'async';
      if ('fetchPriority' in img) { img.fetchPriority = 'low'; }
      // Le misure dipendono dall'immagine solo per il drop-shadow, ma un
      // reflow dopo il caricamento capita comunque: rimisuriamo.
      img.addEventListener('load', function () { measure(); apply(); kick(); });
      img.src = srcs[Math.floor(Math.random() * srcs.length)];
      inner.appendChild(img);
    }


    /* --- geometria --- */
    var P = { size: 0, a0: 0, a1: 0, c0: 1, c1: 2 };

    function measure() {
      var vh = window.innerHeight;
      var y = window.pageYOffset;

      P.size = stage.offsetWidth;

      var sRect = startEl.getBoundingClientRect();
      var sTop = sRect.top + y;

      // Il riferimento per l'uscita.
      //
      // Con una row di uscita indicata: il suo bordo ALTO, cosi la pizza e
      // gia fuori prima che quella row si prenda la scena.
      //
      // Senza: il bordo BASSO della row che la ospita — la pizza entra ed
      // esce dentro la row in cui e stata inserita, e non prosegue fino in
      // fondo alla pagina.
      var eTop = endEl
        ? endEl.getBoundingClientRect().top + y
        : sRect.bottom + y;

      P.a0 = sTop - vh * 0.35;   // parte mentre la row precedente sta uscendo
      P.a1 = P.a0 + vh * 0.65;   // fine entrata: metà pizza visibile

      // L'uscita comincia quando il bordo alto della row finale è ancora mezzo
      // schermo sotto e finisce quando lo tocca: la pizza è già fuori prima che
      // quella row occupi la fascia bassa.
      P.c0 = eTop - vh * 1.5;
      P.c1 = eTop - vh;

      // Su pagine corte, o con le due ancore vicine, l'uscita finirebbe prima
      // dell'entrata e il tragitto avrebbe lunghezza negativa.
      if (P.c0 < P.a1) { P.c0 = P.a1; }
      if (P.c1 <= P.c0) { P.c1 = P.c0 + 1; }
      if (P.c1 <= P.a0) { P.c1 = P.a0 + 1; }
    }

    function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    function lerp(a, b, t) { return a + (b - a) * t; }
    // accelera e decelera dolcemente: usato solo per l'uscita
    function easeIO(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }


    /* --- applicazione --- */
    var targetRot = 0;
    var curRot = 0;
    var lastY = null;
    var lastOpacity = null;

    function apply() {
      var s = window.pageYOffset;
      var y;
      var o = 1;

      // y = size/2 → il bordo alto della pizza tocca esattamente il fondo dello
      // schermo: è il punto "appena nascosta", da cui la salita è tutta visibile.
      if (s <= P.a0) {
        y = P.size / 2;
        o = 0;
      } else if (s < P.a1) {                                    // A — entrata
        y = lerp(P.size / 2, 0, clamp((s - P.a0) / (P.a1 - P.a0)));
      } else if (s < P.c0) {                                    // B — viaggio
        y = 0;
      } else {                                                  // C — uscita
        // Niente dissolvenza: una pizza semitrasparente sopra un titolo si
        // legge come una macchia. Esce scendendo, come è entrata.
        y = lerp(0, P.size / 2, easeIO(clamp((s - P.c0) / (P.c1 - P.c0))));
      }

      if (y !== lastY) {
        stage.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0)';
        lastY = y;
      }
      if (o !== lastOpacity) {
        stage.style.opacity = o;
        lastOpacity = o;
      }

      // Rotazione proporzionale al tragitto percorso.
      targetRot = clamp((s - P.a0) / (P.c1 - P.a0)) * SPIN;
    }


    /* --- il loop ---
       Il lerp sulla rotazione dà l'inerzia dello "scrub". Il rAF si spegne da
       solo quando la rotazione ha raggiunto il target e lo scroll lo riaccende:
       a pagina ferma non gira nulla. */
    var running = false;

    function frame() {
      apply();

      var d = targetRot - curRot;
      if (Math.abs(d) < 0.02) { curRot = targetRot; }
      else { curRot += d * 0.12; }   // ≈ mezzo secondo per raggiungere il target

      inner.style.transform = 'rotate(' + curRot.toFixed(3) + 'deg)';

      if (curRot !== targetRot) { requestAnimationFrame(frame); }
      else { running = false; }
    }

    function kick() {
      if (running || !active) { return; }
      running = true;
      requestAnimationFrame(frame);
    }

    function remeasure() { measure(); apply(); kick(); }


    /* --- accensione e spegnimento ---
       Il pubblico con prefers-reduced-motion e i viewport troppo stretti non
       vedono la pizza, ma la pagina resta valida: lo stage torna hidden. */
    var active = false;
    var ro = null;
    var resizeTimer = null;

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(remeasure, 200);
    }

    function enable() {
      if (active) { return; }
      active = true;

      stage.hidden = false;     // offsetWidth è 0 finché è nascosto
      mountImage();
      measure();
      apply();
      curRot = targetRot;       // al primo giro nessuna rincorsa
      inner.style.transform = 'rotate(' + curRot.toFixed(3) + 'deg)';

      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('resize', onResize);

      // Le row cambiano altezza dopo il lazy load delle immagini e con le row
      // full-height di Salient: il solo resize della finestra non basta.
      if (window.ResizeObserver) {
        ro = new ResizeObserver(onResize);
        ro.observe(startEl);
        if (endEl) { ro.observe(endEl); }
      }

      kick();
    }

    function disable() {
      if (!active) { return; }
      active = false;

      stage.hidden = true;
      lastY = null;
      lastOpacity = null;

      window.removeEventListener('scroll', kick);
      window.removeEventListener('resize', onResize);
      if (ro) { ro.disconnect(); ro = null; }
    }

    function sync() {
      if (mqReduced.matches || (mqNarrow && mqNarrow.matches)) { disable(); }
      else { enable(); }
    }

    mqReduced.addEventListener('change', sync);
    if (mqNarrow) { mqNarrow.addEventListener('change', sync); }

    sync();

    // I font cambiano l'altezza dei blocchi: senza aspettarli, le ancore
    // finiscono su misure sbagliate.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(remeasure);
    }
    window.addEventListener('load', remeasure);
  }


  /* ------------------------------------------------------------------
     10. AVVIO
     ------------------------------------------------------------------ */
  function init() {
    initPizza();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
